import React from "react";

const MicroBladingWhat = () => {
  return (
    <div className="nailExtensionMaintain">
      <h5>
        What to Expect During Your Eyebrow Microblading in Bangalore at SCENT
      </h5>
      <p>
        When you book a session for Eyebrow Microblading in Bangalore at SCENT,
        you can expect a comprehensive and luxurious experience designed to
        enhance your natural beauty. Here’s what the process entails:
      </p>
      <ul>
        <li>
          <h6>1. Initial Consultation</h6>Your journey with SCENT begins with an
          initial consultation. During this session, we discuss your desired
          look, review your eyebrow shape, and choose the perfect pigment color.
          We also go over the procedure in detail and answer any questions you
          may have.
        </li>
        <li>
          <h6>2. Brow Mapping</h6>Next, our technician will map out your new
          brows using a specialized brow mapping technique. This ensures
          symmetry and precision, creating a blueprint for the microblading
          process. You’ll have the opportunity to approve the shape before we
          begin.
        </li>
        <li>
          <h6>3. Numbing </h6>To ensure your comfort, a numbing cream is applied
          to your eyebrows. This minimizes any discomfort during the
          microblading process.
        </li>
        <li>
          <h6>4. Microblading</h6>
          Using a fine blade, our technician will create hair-like strokes to
          mimic your natural eyebrow hairs. This meticulous process ensures a
          natural and realistic look. The pigment is carefully applied to
          achieve the desired shape and fullness.
        </li>
        <li>
          <h6>5. Aftercare Instructions</h6>
          After the procedure, our technician will provide detailed aftercare
          instructions to ensure the best results. Proper aftercare is essential
          for the longevity and appearance of your microbladed brows.
        </li>
      </ul>
    </div>
  );
};

export default MicroBladingWhat;
